import { toast } from "react-toastify";
import moment from "moment";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { notifiy } from "../notification/Notification";
const user = [localStorage.getItem("id"), localStorage.getItem("userName")];  

async function ServeDates() {
  try {
    const { data } = await axiosWithToken.post(`${BASE_URL}dynamic`, { query: 'SELECT now() as date' });
    return new Date(data[0]?.date ?? null);
  } catch (e) {
    console.error(e);
    return 0;
  }
}

export const auhtorityWiseApprove = async (
  action,
  id,
  testedBy,
  rejectionMessage,
  usercurrentRole,
  authorisdby,
) => {
   let url = BASE_URL;
  let data = {};
  let dateTime = await ServeDates();


  switch (action) {
    case "reject":
      data.reviewedBy = null;
      data.reviewedDate = null;
      data.authorizedBy = null;
      data.authorizedDate = null;
      data.preparedBy = null;
      data.preparedDate = null;
      data.rejectedBy = Number(user[0]);
      break;
    
    case "prepared":
      data.preparedBy = user[0];
      data.preparedDate = moment(dateTime).format("YYYY-MM-DD HH:mm:ss");
      break;

    case "review":
      data.reviewedBy = user[0];
      data.reviewedDate = moment(dateTime).format("YYYY-MM-DD HH:mm:ss");
      break;

    case "authorized":
      data.authorizedBy = Number(user[0]);
      data.authorizedDate = moment(dateTime).format("YYYY-MM-DD HH:mm:ss");
      break;

    default:
      break;
  }

  id?.map((e) => {
    axiosWithToken
      .patch(url + `certificate/${e}`, data)
      .then(async (res) => {
        toast.success(
          `Certificate is ${
            {
              authorized: "Authorized",
              reject: "Rejected",
              review: "Review",
              prepared: "Prepared",
            }[action]
          } successfully!`
        );
        //TODO: Need to update _to once notification module is perfected.
        if (action === "reject") {
          const notification = {
            _from: user[0],
            _to: testedBy[0],
            body: ` certificate rejected (${usercurrentRole}) :\n ${rejectionMessage}`,
            type: 1,
          };
          notifiy(notification, () => {
            console.log(`Notified of rejection to ${testedBy[1]}`);
          });
          if (authorisdby[0] && testedBy[0] !== authorisdby[0]) {
            const secondNotification = {
              _from: user[0],
              _to: authorisdby[0],
              body: ` certificate rejected (${usercurrentRole}) :\n ${rejectionMessage}`,
              type: 1,
            };
            notifiy(secondNotification, () => {
              console.log(`Notified of rejection to ${authorisdby[1]}`);
            });
          }
          setTimeout(window.location.reload(false), 500);
        }
       setTimeout(window.location.reload(), 500);
      })
      .catch((err) => {
        console.log(err);
      });
  });
};
